import React, { useEffect, useState } from "react";
const SuccessReservation = ({ codeConfirm }) => {

    const [fecha, setFecha] = useState('')
    const [hora, setHora] = useState('')
    const [code, setCodigo] = useState('')

    useEffect(() => {
        setFecha(localStorage.getItem('fecha'))
        setHora(localStorage.getItem('horaReservada'))
        setCodigo(localStorage.getItem('rsvCode'))
    }, [

    ])

    return (
        <div>
            <h3>Reserva Generada Exitosamente</h3>
            <h4>Fecha:{' '}{fecha}</h4>
            <h4>Hora:{' '}{hora}</h4>
            <div><span style={{ fontWeigth: 'bolder' }}>Código de confirmacion:</span><h2>{codeConfirm}</h2></div>
        </div>
    )
}

export default SuccessReservation